import React from 'react'
import PropTypes from 'prop-types'
import { Navigate } from 'react-router-dom'
import useIsLogin from '../../hooks/useIsLogin'
const ProtectedRoute = (props) => {
  const { redirectPath = '/login', children } = props
  const isLoggedIn = useIsLogin()
  if (!isLoggedIn) {
    return <Navigate to={redirectPath} replace />
  }

  return children
}
ProtectedRoute.propTypes = {
  children: PropTypes.node,
  redirectPath: PropTypes.string,
}
export default ProtectedRoute
